import React, { useState } from "react";
import {
  Button,
  Col,
  Container,
  Dropdown,
  Form,
  Image,
  Row,
  Modal,
  Carousel,
  Pagination,
} from "react-bootstrap";
import { Icon } from "@iconify/react";
import { IMAGES } from "../../../assets/images/images";
import { Link } from "react-router-dom";
import CustomRadioButton from "../../../components/customcomponents/customradiobutton/CustomRadioButton";
import ReactSlider from "react-slider";
import SliderCategory from "../../../components/customcomponents/SliderCategory";

const listingsData = [
  {
    id: 1,
    title: "Casa Lomas de Machalí Machas",
    location: "33 Street, San Francisco, California",
    price: "$7250.00",
    rating: 4.5,
    images: [IMAGES.List1, IMAGES.List2, IMAGES.List3],
    amenities: [
      "fluent:swimming-pool-20-filled",
      "solar:bath-outline",
      "tabler:wifi",
      "lucide:tv",
    ],
  },
  {
    id: 2,
    title: "Villa Del Mar Retreat, Malibu",
    location: "33 Street, San Francisco, California",
    price: "$7250.00",
    rating: 4.5,
    images: [IMAGES.List1, IMAGES.List2, IMAGES.List3],
    amenities: [
      "fluent:swimming-pool-20-filled",
      "solar:bath-outline",
      "tabler:wifi",
      "lucide:tv",
    ],
  },
  {
    id: 3,
    title: "Rancho Vista Verde, Santa Barbara",
    location: "33 Street, San Francisco, California",
    price: "$7250.00",
    rating: 4.5,
    images: [IMAGES.List1, IMAGES.List2, IMAGES.List3],
    amenities: [
      "fluent:swimming-pool-20-filled",
      "solar:bath-outline",
      "tabler:wifi",
      "lucide:tv",
    ],
  },
  {
    id: 4,
    title: "Sunset Heights Estate, Beverly Hills",
    location: "33 Street, San Francisco, California",
    price: "$7250.00",
    rating: 4.5,
    images: [IMAGES.List1, IMAGES.List2, IMAGES.List3],
    amenities: [
      "fluent:swimming-pool-20-filled",
      "solar:bath-outline",
      "tabler:wifi",
      "lucide:tv",
    ],
  },
  {
    id: 5,
    title: "Casa Lomas de Machalí Machas",
    location: "33 Street, San Francisco, California",
    price: "$7250.00",
    rating: 4.5,
    images: [IMAGES.List1, IMAGES.List2, IMAGES.List3],
    amenities: [
      "fluent:swimming-pool-20-filled",
      "solar:bath-outline",
      "tabler:wifi",
      "lucide:tv",
    ],
  },
  {
    id: 6,
    title: "Villa Del Mar Retreat, Malibu",
    location: "33 Street, San Francisco, California",
    price: "$7250.00",
    rating: 4.5,
    images: [IMAGES.List1, IMAGES.List2, IMAGES.List3],
    amenities: [
      "fluent:swimming-pool-20-filled",
      "solar:bath-outline",
      "tabler:wifi",
      "lucide:tv",
    ],
  },
  {
    id: 7,
    title: "Rancho Vista Verde, Santa Barbara",
    location: "33 Street, San Francisco, California",
    price: "$7250.00",
    rating: 4.5,
    images: [IMAGES.List1, IMAGES.List2, IMAGES.List3],
    amenities: [
      "fluent:swimming-pool-20-filled",
      "solar:bath-outline",
      "tabler:wifi",
      "lucide:tv",
    ],
  },
  {
    id: 8,
    title: "Sunset Heights Estate, Beverly Hills",
    location: "33 Street, San Francisco, California",
    price: "$7250.00",
    rating: 4.5,
    images: [IMAGES.List1, IMAGES.List2, IMAGES.List3],
    amenities: [
      "fluent:swimming-pool-20-filled",
      "solar:bath-outline",
      "tabler:wifi",
      "lucide:tv",
    ],
  },
  {
    id: 9,
    title: "Casa Lomas de Machalí Machas",
    location: "33 Street, San Francisco, California",
    price: "$7250.00",
    rating: 4.5,
    images: [IMAGES.List1, IMAGES.List2, IMAGES.List3],
    amenities: [
      "fluent:swimming-pool-20-filled",
      "solar:bath-outline",
      "tabler:wifi",
      "lucide:tv",
    ],
  },
];

const SearchScreen = () => {
  const [num, setNum] = useState(1);
  const [num1, setNum1] = useState(1);
  const [num2, setNum2] = useState(1);

  const CounterI = (e) => {
    e.stopPropagation();
    setNum(num + 1);
  };

  const CounterI1 = (e) => {
    e.stopPropagation();
    setNum1(num1 + 1);
  };

  const CounterI2 = (e) => {
    e.stopPropagation();
    setNum2(num2 + 1);
  };

  const CounterD = (e) => {
    e.stopPropagation();
    setNum(num - 1);
    if (num === 0) {
      setNum(0);
    }
  };

  const CounterD1 = (e) => {
    e.stopPropagation();
    setNum1(num1 - 1);
    if (num1 === 0) {
      setNum1(0);
    }
  };

  const CounterD2 = (e) => {
    e.stopPropagation();
    setNum2(num2 - 1);
    if (num2 === 0) {
      setNum2(0);
    }
  };

  const [modalShow, setModalShow] = React.useState(false);
  const [modalShow1, setModalShow1] = React.useState(false);
  const [modalShow2, setModalShow2] = React.useState(false);

  const items = [
    {
      name: "Villas",
      icon: (
        <svg width="38" height="34" viewBox="0 0 38 34" fill="none">
          <path
            d="M0.0234375 33.95V12.5043L12.4827 0.00250019L24.942 12.5043V33.95H0.0234375ZM2.5153 31.4496H10.564V25.6788H14.399V31.4496H22.4477V13.5095L12.4802 3.50802L2.5128 13.5095L2.5153 31.4496ZM10.564 18.3727V14.5221H14.399V18.3727H10.564ZM28.9664 34V10.8241L18.1791 0H21.72L31.4582 9.77394V33.9975L28.9664 34ZM35.4851 34V8.09619L27.4189 0.00250019H31.0072L37.9769 7.04354V33.9975L35.4851 34Z"
            fill="#1B91BF"
          />
        </svg>
      ),
      badgeCount: 21,
    },
    {
      name: "Hotels",
      icon: (
        <svg width="38" height="38" viewBox="0 0 38 38" fill="none">
          <path
            d="M2 2H36M15.6 25.8H22.4M15.6 25.8V36H22.4V25.8M15.6 25.8H13.9C13.4308 25.8 13.0415 25.4158 13.1316 24.9551C13.6008 22.5403 16.0505 20.7 19 20.7C21.9504 20.7 24.3992 22.5411 24.8684 24.9551C24.9585 25.4158 24.5692 25.8 24.1 25.8H22.4M11.35 8.8H13.05M11.35 13.9H13.05M18.15 8.8H19.85M18.15 13.9H19.85M24.95 8.8H26.65M24.95 13.9H26.65M2 36H36M7.1 2H30.9C31.8389 2 32.6 2.76112 32.6 3.7V34.3C32.6 35.2389 31.8389 36 30.9 36H7.1C6.16112 36 5.4 35.2389 5.4 34.3V3.7C5.4 2.76112 6.16112 2 7.1 2Z"
            stroke="#1B91BF"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),

      badgeCount: 21,
    },
    {
      name: "Apartments",
      icon: (
        <svg width="44" height="34" viewBox="0 0 44 34" fill="none">
          <path
            d="M41.8333 31.1667H40.4167V7.08333C40.4167 6.70761 40.2674 6.34728 40.0017 6.0816C39.7361 5.81592 39.3757 5.66667 39 5.66667H31.9167V1.41667C31.9167 1.04094 31.7674 0.680609 31.5017 0.414932C31.2361 0.149256 30.8757 0 30.5 0H13.5C13.1243 0 12.7639 0.149256 12.4983 0.414932C12.2326 0.680609 12.0833 1.04094 12.0833 1.41667V11.3333H5C4.62428 11.3333 4.26394 11.4826 3.99827 11.7483C3.73259 12.0139 3.58333 12.3743 3.58333 12.75V31.1667H2.16667C1.79094 31.1667 1.43061 31.3159 1.16493 31.5816C0.899255 31.8473 0.75 32.2076 0.75 32.5833C0.75 32.9591 0.899255 33.3194 1.16493 33.5851C1.43061 33.8507 1.79094 34 2.16667 34H41.8333C42.2091 34 42.5694 33.8507 42.8351 33.5851C43.1007 33.3194 43.25 32.9591 43.25 32.5833C43.25 32.2076 43.1007 31.8473 42.8351 31.5816C42.5694 31.3159 42.2091 31.1667 41.8333 31.1667ZM6.41667 14.1667H13.5C13.8757 14.1667 14.2361 14.0174 14.5017 13.7517C14.7674 13.4861 14.9167 13.1257 14.9167 12.75V2.83333H29.0833V7.08333C29.0833 7.45906 29.2326 7.81939 29.4983 8.08507C29.7639 8.35074 30.1243 8.5 30.5 8.5H37.5833V31.1667H26.25V24.0833C26.25 23.7076 26.1007 23.3473 25.8351 23.0816C25.5694 22.8159 25.2091 22.6667 24.8333 22.6667H19.1667C18.7909 22.6667 18.4306 22.8159 18.1649 23.0816C17.8993 23.3473 17.75 23.7076 17.75 24.0833V31.1667H6.41667V14.1667ZM23.4167 31.1667H20.5833V25.5H23.4167V31.1667ZM19.1667 7.08333C19.1667 6.70761 19.3159 6.34728 19.5816 6.0816C19.8473 5.81592 20.2076 5.66667 20.5833 5.66667H23.4167C23.7924 5.66667 24.1527 5.81592 24.4184 6.0816C24.6841 6.34728 24.8333 6.70761 24.8333 7.08333C24.8333 7.45906 24.6841 7.81939 24.4184 8.08507C24.1527 8.35074 23.7924 8.5 23.4167 8.5H20.5833C20.2076 8.5 19.8473 8.35074 19.5816 8.08507C19.3159 7.81939 19.1667 7.45906 19.1667 7.08333ZM19.1667 12.75C19.1667 12.3743 19.3159 12.0139 19.5816 11.7483C19.8473 11.4826 20.2076 11.3333 20.5833 11.3333H23.4167C23.7924 11.3333 24.1527 11.4826 24.4184 11.7483C24.6841 12.0139 24.8333 12.3743 24.8333 12.75C24.8333 13.1257 24.6841 13.4861 24.4184 13.7517C24.1527 14.0174 23.7924 14.1667 23.4167 14.1667H20.5833C20.2076 14.1667 19.8473 14.0174 19.5816 13.7517C19.3159 13.4861 19.1667 13.1257 19.1667 12.75ZM29.0833 12.75C29.0833 12.3743 29.2326 12.0139 29.4983 11.7483C29.7639 11.4826 30.1243 11.3333 30.5 11.3333H33.3333C33.7091 11.3333 34.0694 11.4826 34.3351 11.7483C34.6007 12.0139 34.75 12.3743 34.75 12.75C34.75 13.1257 34.6007 13.4861 34.3351 13.7517C34.0694 14.0174 33.7091 14.1667 33.3333 14.1667H30.5C30.1243 14.1667 29.7639 14.0174 29.4983 13.7517C29.2326 13.4861 29.0833 13.1257 29.0833 12.75ZM14.9167 18.4167C14.9167 18.7924 14.7674 19.1527 14.5017 19.4184C14.2361 19.6841 13.8757 19.8333 13.5 19.8333H10.6667C10.2909 19.8333 9.93061 19.6841 9.66493 19.4184C9.39926 19.1527 9.25 18.7924 9.25 18.4167C9.25 18.0409 9.39926 17.6806 9.66493 17.4149C9.93061 17.1493 10.2909 17 10.6667 17H13.5C13.8757 17 14.2361 17.1493 14.5017 17.4149C14.7674 17.6806 14.9167 18.0409 14.9167 18.4167ZM14.9167 24.0833C14.9167 24.4591 14.7674 24.8194 14.5017 25.0851C14.2361 25.3507 13.8757 25.5 13.5 25.5H10.6667C10.2909 25.5 9.93061 25.3507 9.66493 25.0851C9.39926 24.8194 9.25 24.4591 9.25 24.0833C9.25 23.7076 9.39926 23.3473 9.66493 23.0816C9.93061 22.8159 10.2909 22.6667 10.6667 22.6667H13.5C13.8757 22.6667 14.2361 22.8159 14.5017 23.0816C14.7674 23.3473 14.9167 23.7076 14.9167 24.0833ZM19.1667 18.4167C19.1667 18.0409 19.3159 17.6806 19.5816 17.4149C19.8473 17.1493 20.2076 17 20.5833 17H23.4167C23.7924 17 24.1527 17.1493 24.4184 17.4149C24.6841 17.6806 24.8333 18.0409 24.8333 18.4167C24.8333 18.7924 24.6841 19.1527 24.4184 19.4184C24.1527 19.6841 23.7924 19.8333 23.4167 19.8333H20.5833C20.2076 19.8333 19.8473 19.6841 19.5816 19.4184C19.3159 19.1527 19.1667 18.7924 19.1667 18.4167ZM29.0833 18.4167C29.0833 18.0409 29.2326 17.6806 29.4983 17.4149C29.7639 17.1493 30.1243 17 30.5 17H33.3333C33.7091 17 34.0694 17.1493 34.3351 17.4149C34.6007 17.6806 34.75 18.0409 34.75 18.4167C34.75 18.7924 34.6007 19.1527 34.3351 19.4184C34.0694 19.6841 33.7091 19.8333 33.3333 19.8333H30.5C30.1243 19.8333 29.7639 19.6841 29.4983 19.4184C29.2326 19.1527 29.0833 18.7924 29.0833 18.4167ZM29.0833 24.0833C29.0833 23.7076 29.2326 23.3473 29.4983 23.0816C29.7639 22.8159 30.1243 22.6667 30.5 22.6667H33.3333C33.7091 22.6667 34.0694 22.8159 34.3351 23.0816C34.6007 23.3473 34.75 23.7076 34.75 24.0833C34.75 24.4591 34.6007 24.8194 34.3351 25.0851C34.0694 25.3507 33.7091 25.5 33.3333 25.5H30.5C30.1243 25.5 29.7639 25.3507 29.4983 25.0851C29.2326 24.8194 29.0833 24.4591 29.0833 24.0833Z"
            fill="#1B91BF"
          />
        </svg>
      ),
      badgeCount: 21,
    },
    {
      name: "Rooms",
      icon: (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
          <path
            d="M5.94133 26.4282H7.61111V23.4494H28.3889V26.4282H30.0606V19.955C30.0606 19.4639 29.9346 18.9507 29.6828 18.4156C29.4309 17.8804 29.0846 17.4535 28.6439 17.1349V13.9313C28.6439 13.0624 28.3524 12.3365 27.7693 11.7534C27.1863 11.1704 26.4603 10.8795 25.5914 10.8808H20.108C19.6156 10.8808 19.1938 10.9702 18.8424 11.149C18.4911 11.3291 18.2103 11.574 18 11.8838C17.7897 11.574 17.5089 11.3291 17.1576 11.149C16.8062 10.9702 16.3844 10.8808 15.892 10.8808H10.4104C9.54155 10.8808 8.81559 11.1717 8.23255 11.7534C7.64952 12.3352 7.35863 13.0612 7.35989 13.9313V17.1349C6.91915 17.4547 6.57285 17.8816 6.321 18.4156C6.06915 18.9495 5.94322 19.4626 5.94322 19.955L5.94133 26.4282ZM7.61111 21.7778V19.8889C7.61111 19.3537 7.79244 18.9054 8.15511 18.544C8.51778 18.1826 8.96607 18.0013 9.5 18H26.5C27.0352 18 27.4841 18.1813 27.8468 18.544C28.2094 18.9067 28.3901 19.355 28.3889 19.8889V21.7778H7.61111ZM9.02778 16.3302V13.7122C9.02778 13.3722 9.1367 13.0939 9.35455 12.8773C9.57241 12.6595 9.85133 12.5506 10.1913 12.5506H16.0016C16.3416 12.5506 16.6199 12.6595 16.8364 12.8773C17.0556 13.0952 17.1651 13.3735 17.1651 13.7122V16.3283L9.02778 16.3302ZM18.8349 16.3302V13.7122C18.8349 13.3722 18.9444 13.0939 19.1636 12.8773C19.3814 12.6595 19.6597 12.5506 19.9984 12.5506H25.8106C26.1493 12.5506 26.4276 12.6595 26.6454 12.8773C26.8633 13.0952 26.9722 13.3735 26.9722 13.7122V16.3283L18.8349 16.3302ZM4.05244 35C3.1823 35 2.45633 34.7091 1.87456 34.1273C1.29278 33.5456 1.00126 32.8196 1 31.9494V4.05055C1 3.18167 1.29152 2.45633 1.87456 1.87456C2.45759 1.29278 3.18293 1.00126 4.05055 1H31.9494C32.8183 1 33.5437 1.29152 34.1254 1.87456C34.7072 2.45759 34.9987 3.18356 35 4.05244V31.9494C35 32.8183 34.7085 33.5443 34.1254 34.1273C33.5424 34.7104 32.8171 35.0013 31.9494 35H4.05244ZM4.05244 33.1111H31.9494C32.2391 33.1111 32.5054 32.9902 32.7484 32.7484C32.9915 32.5067 33.1124 32.2397 33.1111 31.9476V4.05244C33.1111 3.76156 32.9902 3.49459 32.7484 3.25156C32.5067 3.00852 32.2403 2.88763 31.9494 2.88889H4.05055C3.76093 2.88889 3.49459 3.00978 3.25156 3.25156C3.00852 3.49333 2.88763 3.75967 2.88889 4.05055V31.9494C2.88889 32.2391 3.00978 32.5054 3.25156 32.7484C3.49333 32.9915 3.75967 33.1124 4.05055 33.1111"
            fill="#1B91BF"
          />
          <path
            d="M4.05244 33.1111H31.9494C32.2391 33.1111 32.5054 32.9902 32.7484 32.7484C32.9915 32.5067 33.1124 32.2397 33.1111 31.9476V4.05244C33.1111 3.76156 32.9902 3.49459 32.7484 3.25156C32.5067 3.00852 32.2403 2.88763 31.9494 2.88889H4.05055C3.76093 2.88889 3.49459 3.00978 3.25156 3.25156C3.00852 3.49333 2.88763 3.75967 2.88889 4.05055V31.9494C2.88889 32.2391 3.00978 32.5054 3.25156 32.7484C3.49333 32.9915 3.75967 33.1124 4.05055 33.1111M2.88889 33.1111V2.88889M5.94133 26.4282H7.61111V23.4494H28.3889V26.4282H30.0606V19.955C30.0606 19.4639 29.9346 18.9507 29.6828 18.4156C29.4309 17.8804 29.0846 17.4535 28.6439 17.1349V13.9313C28.6439 13.0624 28.3524 12.3365 27.7693 11.7534C27.1863 11.1704 26.4603 10.8795 25.5914 10.8808H20.108C19.6156 10.8808 19.1938 10.9702 18.8424 11.149C18.4911 11.3291 18.2103 11.574 18 11.8838C17.7897 11.574 17.5089 11.3291 17.1576 11.149C16.8062 10.9702 16.3844 10.8808 15.892 10.8808H10.4104C9.54155 10.8808 8.81559 11.1717 8.23255 11.7534C7.64952 12.3352 7.35863 13.0612 7.35989 13.9313V17.1349C6.91915 17.4547 6.57285 17.8816 6.321 18.4156C6.06915 18.9495 5.94322 19.4626 5.94322 19.955L5.94133 26.4282ZM7.61111 21.7778V19.8889C7.61111 19.3537 7.79244 18.9054 8.15511 18.544C8.51778 18.1826 8.96607 18.0013 9.5 18H26.5C27.0352 18 27.4841 18.1813 27.8468 18.544C28.2094 18.9067 28.3901 19.355 28.3889 19.8889V21.7778H7.61111ZM9.02778 16.3302V13.7122C9.02778 13.3722 9.1367 13.0939 9.35455 12.8773C9.57241 12.6595 9.85133 12.5506 10.1913 12.5506H16.0016C16.3416 12.5506 16.6199 12.6595 16.8364 12.8773C17.0556 13.0952 17.1651 13.3735 17.1651 13.7122V16.3283L9.02778 16.3302ZM18.8349 16.3302V13.7122C18.8349 13.3722 18.9444 13.0939 19.1636 12.8773C19.3814 12.6595 19.6597 12.5506 19.9984 12.5506H25.8106C26.1493 12.5506 26.4276 12.6595 26.6454 12.8773C26.8633 13.0952 26.9722 13.3735 26.9722 13.7122V16.3283L18.8349 16.3302ZM4.05244 35C3.1823 35 2.45633 34.7091 1.87456 34.1273C1.29278 33.5456 1.00126 32.8196 1 31.9494V4.05055C1 3.18167 1.29152 2.45633 1.87456 1.87456C2.45759 1.29278 3.18293 1.00126 4.05055 1H31.9494C32.8183 1 33.5437 1.29152 34.1254 1.87456C34.7072 2.45759 34.9987 3.18356 35 4.05244V31.9494C35 32.8183 34.7085 33.5443 34.1254 34.1273C33.5424 34.7104 32.8171 35.0013 31.9494 35H4.05244Z"
            stroke="#1B91BF"
          />
        </svg>
      ),

      badgeCount: 21,
    },
    {
      name: "Caravans",
      icon: (
        <svg width="46" height="34" viewBox="0 0 46 34" fill="none">
          <path
            d="M16.6247 21.25C13.083 21.25 10.2497 24.0833 10.2497 27.625C10.2497 31.1667 13.083 34 16.6247 34C20.1663 34 22.9997 31.1667 22.9997 27.625C22.9997 24.0833 20.1663 21.25 16.6247 21.25ZM16.6247 31.1667C14.6413 31.1667 13.083 29.6083 13.083 27.625C13.083 25.6417 14.6413 24.0833 16.6247 24.0833C18.608 24.0833 20.1663 25.6417 20.1663 27.625C20.1663 29.6083 18.608 31.1667 16.6247 31.1667Z"
            fill="#1B91BF"
          />
          <path
            d="M44.2497 25.5H41.4163V14.875C41.4163 14.1667 41.2747 13.4583 40.8497 12.75L34.8997 2.125C34.1913 0.708333 32.7747 0 31.2163 0H4.58301C2.17467 0 0.333008 1.84167 0.333008 4.25V24.0833C0.333008 26.4917 2.17467 28.3333 4.58301 28.3333H7.41634V25.5H4.58301C3.73301 25.5 3.16634 24.9333 3.16634 24.0833V4.25C3.16634 3.4 3.73301 2.83333 4.58301 2.83333H31.2163C31.783 2.83333 32.208 3.11667 32.4913 3.54167L38.4413 14.1667C38.583 14.3083 38.583 14.5917 38.583 14.875V25.5H32.9163V8.5H22.9997V19.8333H25.833V11.3333H30.083V25.5H25.833V28.3333H44.2497C45.0997 28.3333 45.6663 27.7667 45.6663 26.9167C45.6663 26.0667 45.0997 25.5 44.2497 25.5Z"
            fill="#1B91BF"
          />
          <path
            d="M20.1663 8.5H7.41634V17H20.1663V8.5ZM17.333 14.1667H10.2497V11.3333H17.333V14.1667Z"
            fill="#1B91BF"
          />
        </svg>
      ),
      badgeCount: 21,
    },
    {
      name: "Huts",
      icon: (
        <svg width="40" height="34" viewBox="0 0 40 34" fill="none">
          <path
            d="M20.7999 0.27916C20.5679 0.0982485 20.282 0 19.9878 0C19.6936 0 19.4078 0.0982485 19.1757 0.27916L0.383789 14.9322L2.00928 16.9879L4.30695 15.1963V31.3846C4.30833 32.0778 4.58433 32.7422 5.07452 33.2324C5.56471 33.7226 6.22915 33.9986 6.92238 34H33.0768C33.77 33.9986 34.4344 33.7226 34.9246 33.2324C35.4148 32.7422 35.6908 32.0778 35.6922 31.3846V15.2081L37.9899 16.9997L39.6154 14.9439L20.7999 0.27916ZM22.615 31.3846H17.3841V20.9228H22.615V31.3846ZM25.2304 31.3846V20.9228C25.2304 20.2292 24.9549 19.5639 24.4644 19.0734C23.9739 18.5829 23.3087 18.3074 22.615 18.3074H17.3841C16.6905 18.3074 16.0252 18.5829 15.5347 19.0734C15.0443 19.5639 14.7687 20.2292 14.7687 20.9228V31.3846H6.92238V13.1576L19.9996 2.97045L33.0768 13.1707V31.3846H25.2304Z"
            fill="#1B91BF"
          />
        </svg>
      ),
      badgeCount: 21,
    },
    {
      name: "Villas",
      icon: (
        <svg width="38" height="34" viewBox="0 0 38 34" fill="none">
          <path
            d="M0.0234375 33.95V12.5043L12.4827 0.00250019L24.942 12.5043V33.95H0.0234375ZM2.5153 31.4496H10.564V25.6788H14.399V31.4496H22.4477V13.5095L12.4802 3.50802L2.5128 13.5095L2.5153 31.4496ZM10.564 18.3727V14.5221H14.399V18.3727H10.564ZM28.9664 34V10.8241L18.1791 0H21.72L31.4582 9.77394V33.9975L28.9664 34ZM35.4851 34V8.09619L27.4189 0.00250019H31.0072L37.9769 7.04354V33.9975L35.4851 34Z"
            fill="#1B91BF"
          />
        </svg>
      ),
      badgeCount: 21,
    },
    {
      name: "Hotels",
      icon: (
        <svg width="38" height="38" viewBox="0 0 38 38" fill="none">
          <path
            d="M2 2H36M15.6 25.8H22.4M15.6 25.8V36H22.4V25.8M15.6 25.8H13.9C13.4308 25.8 13.0415 25.4158 13.1316 24.9551C13.6008 22.5403 16.0505 20.7 19 20.7C21.9504 20.7 24.3992 22.5411 24.8684 24.9551C24.9585 25.4158 24.5692 25.8 24.1 25.8H22.4M11.35 8.8H13.05M11.35 13.9H13.05M18.15 8.8H19.85M18.15 13.9H19.85M24.95 8.8H26.65M24.95 13.9H26.65M2 36H36M7.1 2H30.9C31.8389 2 32.6 2.76112 32.6 3.7V34.3C32.6 35.2389 31.8389 36 30.9 36H7.1C6.16112 36 5.4 35.2389 5.4 34.3V3.7C5.4 2.76112 6.16112 2 7.1 2Z"
            stroke="#1B91BF"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),

      badgeCount: 21,
    },
    {
      name: "Apartments",
      icon: (
        <svg width="44" height="34" viewBox="0 0 44 34" fill="none">
          <path
            d="M41.8333 31.1667H40.4167V7.08333C40.4167 6.70761 40.2674 6.34728 40.0017 6.0816C39.7361 5.81592 39.3757 5.66667 39 5.66667H31.9167V1.41667C31.9167 1.04094 31.7674 0.680609 31.5017 0.414932C31.2361 0.149256 30.8757 0 30.5 0H13.5C13.1243 0 12.7639 0.149256 12.4983 0.414932C12.2326 0.680609 12.0833 1.04094 12.0833 1.41667V11.3333H5C4.62428 11.3333 4.26394 11.4826 3.99827 11.7483C3.73259 12.0139 3.58333 12.3743 3.58333 12.75V31.1667H2.16667C1.79094 31.1667 1.43061 31.3159 1.16493 31.5816C0.899255 31.8473 0.75 32.2076 0.75 32.5833C0.75 32.9591 0.899255 33.3194 1.16493 33.5851C1.43061 33.8507 1.79094 34 2.16667 34H41.8333C42.2091 34 42.5694 33.8507 42.8351 33.5851C43.1007 33.3194 43.25 32.9591 43.25 32.5833C43.25 32.2076 43.1007 31.8473 42.8351 31.5816C42.5694 31.3159 42.2091 31.1667 41.8333 31.1667ZM6.41667 14.1667H13.5C13.8757 14.1667 14.2361 14.0174 14.5017 13.7517C14.7674 13.4861 14.9167 13.1257 14.9167 12.75V2.83333H29.0833V7.08333C29.0833 7.45906 29.2326 7.81939 29.4983 8.08507C29.7639 8.35074 30.1243 8.5 30.5 8.5H37.5833V31.1667H26.25V24.0833C26.25 23.7076 26.1007 23.3473 25.8351 23.0816C25.5694 22.8159 25.2091 22.6667 24.8333 22.6667H19.1667C18.7909 22.6667 18.4306 22.8159 18.1649 23.0816C17.8993 23.3473 17.75 23.7076 17.75 24.0833V31.1667H6.41667V14.1667ZM23.4167 31.1667H20.5833V25.5H23.4167V31.1667ZM19.1667 7.08333C19.1667 6.70761 19.3159 6.34728 19.5816 6.0816C19.8473 5.81592 20.2076 5.66667 20.5833 5.66667H23.4167C23.7924 5.66667 24.1527 5.81592 24.4184 6.0816C24.6841 6.34728 24.8333 6.70761 24.8333 7.08333C24.8333 7.45906 24.6841 7.81939 24.4184 8.08507C24.1527 8.35074 23.7924 8.5 23.4167 8.5H20.5833C20.2076 8.5 19.8473 8.35074 19.5816 8.08507C19.3159 7.81939 19.1667 7.45906 19.1667 7.08333ZM19.1667 12.75C19.1667 12.3743 19.3159 12.0139 19.5816 11.7483C19.8473 11.4826 20.2076 11.3333 20.5833 11.3333H23.4167C23.7924 11.3333 24.1527 11.4826 24.4184 11.7483C24.6841 12.0139 24.8333 12.3743 24.8333 12.75C24.8333 13.1257 24.6841 13.4861 24.4184 13.7517C24.1527 14.0174 23.7924 14.1667 23.4167 14.1667H20.5833C20.2076 14.1667 19.8473 14.0174 19.5816 13.7517C19.3159 13.4861 19.1667 13.1257 19.1667 12.75ZM29.0833 12.75C29.0833 12.3743 29.2326 12.0139 29.4983 11.7483C29.7639 11.4826 30.1243 11.3333 30.5 11.3333H33.3333C33.7091 11.3333 34.0694 11.4826 34.3351 11.7483C34.6007 12.0139 34.75 12.3743 34.75 12.75C34.75 13.1257 34.6007 13.4861 34.3351 13.7517C34.0694 14.0174 33.7091 14.1667 33.3333 14.1667H30.5C30.1243 14.1667 29.7639 14.0174 29.4983 13.7517C29.2326 13.4861 29.0833 13.1257 29.0833 12.75ZM14.9167 18.4167C14.9167 18.7924 14.7674 19.1527 14.5017 19.4184C14.2361 19.6841 13.8757 19.8333 13.5 19.8333H10.6667C10.2909 19.8333 9.93061 19.6841 9.66493 19.4184C9.39926 19.1527 9.25 18.7924 9.25 18.4167C9.25 18.0409 9.39926 17.6806 9.66493 17.4149C9.93061 17.1493 10.2909 17 10.6667 17H13.5C13.8757 17 14.2361 17.1493 14.5017 17.4149C14.7674 17.6806 14.9167 18.0409 14.9167 18.4167ZM14.9167 24.0833C14.9167 24.4591 14.7674 24.8194 14.5017 25.0851C14.2361 25.3507 13.8757 25.5 13.5 25.5H10.6667C10.2909 25.5 9.93061 25.3507 9.66493 25.0851C9.39926 24.8194 9.25 24.4591 9.25 24.0833C9.25 23.7076 9.39926 23.3473 9.66493 23.0816C9.93061 22.8159 10.2909 22.6667 10.6667 22.6667H13.5C13.8757 22.6667 14.2361 22.8159 14.5017 23.0816C14.7674 23.3473 14.9167 23.7076 14.9167 24.0833ZM19.1667 18.4167C19.1667 18.0409 19.3159 17.6806 19.5816 17.4149C19.8473 17.1493 20.2076 17 20.5833 17H23.4167C23.7924 17 24.1527 17.1493 24.4184 17.4149C24.6841 17.6806 24.8333 18.0409 24.8333 18.4167C24.8333 18.7924 24.6841 19.1527 24.4184 19.4184C24.1527 19.6841 23.7924 19.8333 23.4167 19.8333H20.5833C20.2076 19.8333 19.8473 19.6841 19.5816 19.4184C19.3159 19.1527 19.1667 18.7924 19.1667 18.4167ZM29.0833 18.4167C29.0833 18.0409 29.2326 17.6806 29.4983 17.4149C29.7639 17.1493 30.1243 17 30.5 17H33.3333C33.7091 17 34.0694 17.1493 34.3351 17.4149C34.6007 17.6806 34.75 18.0409 34.75 18.4167C34.75 18.7924 34.6007 19.1527 34.3351 19.4184C34.0694 19.6841 33.7091 19.8333 33.3333 19.8333H30.5C30.1243 19.8333 29.7639 19.6841 29.4983 19.4184C29.2326 19.1527 29.0833 18.7924 29.0833 18.4167ZM29.0833 24.0833C29.0833 23.7076 29.2326 23.3473 29.4983 23.0816C29.7639 22.8159 30.1243 22.6667 30.5 22.6667H33.3333C33.7091 22.6667 34.0694 22.8159 34.3351 23.0816C34.6007 23.3473 34.75 23.7076 34.75 24.0833C34.75 24.4591 34.6007 24.8194 34.3351 25.0851C34.0694 25.3507 33.7091 25.5 33.3333 25.5H30.5C30.1243 25.5 29.7639 25.3507 29.4983 25.0851C29.2326 24.8194 29.0833 24.4591 29.0833 24.0833Z"
            fill="#1B91BF"
          />
        </svg>
      ),
      badgeCount: 21,
    },
    {
      name: "Rooms",
      icon: (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
          <path
            d="M5.94133 26.4282H7.61111V23.4494H28.3889V26.4282H30.0606V19.955C30.0606 19.4639 29.9346 18.9507 29.6828 18.4156C29.4309 17.8804 29.0846 17.4535 28.6439 17.1349V13.9313C28.6439 13.0624 28.3524 12.3365 27.7693 11.7534C27.1863 11.1704 26.4603 10.8795 25.5914 10.8808H20.108C19.6156 10.8808 19.1938 10.9702 18.8424 11.149C18.4911 11.3291 18.2103 11.574 18 11.8838C17.7897 11.574 17.5089 11.3291 17.1576 11.149C16.8062 10.9702 16.3844 10.8808 15.892 10.8808H10.4104C9.54155 10.8808 8.81559 11.1717 8.23255 11.7534C7.64952 12.3352 7.35863 13.0612 7.35989 13.9313V17.1349C6.91915 17.4547 6.57285 17.8816 6.321 18.4156C6.06915 18.9495 5.94322 19.4626 5.94322 19.955L5.94133 26.4282ZM7.61111 21.7778V19.8889C7.61111 19.3537 7.79244 18.9054 8.15511 18.544C8.51778 18.1826 8.96607 18.0013 9.5 18H26.5C27.0352 18 27.4841 18.1813 27.8468 18.544C28.2094 18.9067 28.3901 19.355 28.3889 19.8889V21.7778H7.61111ZM9.02778 16.3302V13.7122C9.02778 13.3722 9.1367 13.0939 9.35455 12.8773C9.57241 12.6595 9.85133 12.5506 10.1913 12.5506H16.0016C16.3416 12.5506 16.6199 12.6595 16.8364 12.8773C17.0556 13.0952 17.1651 13.3735 17.1651 13.7122V16.3283L9.02778 16.3302ZM18.8349 16.3302V13.7122C18.8349 13.3722 18.9444 13.0939 19.1636 12.8773C19.3814 12.6595 19.6597 12.5506 19.9984 12.5506H25.8106C26.1493 12.5506 26.4276 12.6595 26.6454 12.8773C26.8633 13.0952 26.9722 13.3735 26.9722 13.7122V16.3283L18.8349 16.3302ZM4.05244 35C3.1823 35 2.45633 34.7091 1.87456 34.1273C1.29278 33.5456 1.00126 32.8196 1 31.9494V4.05055C1 3.18167 1.29152 2.45633 1.87456 1.87456C2.45759 1.29278 3.18293 1.00126 4.05055 1H31.9494C32.8183 1 33.5437 1.29152 34.1254 1.87456C34.7072 2.45759 34.9987 3.18356 35 4.05244V31.9494C35 32.8183 34.7085 33.5443 34.1254 34.1273C33.5424 34.7104 32.8171 35.0013 31.9494 35H4.05244ZM4.05244 33.1111H31.9494C32.2391 33.1111 32.5054 32.9902 32.7484 32.7484C32.9915 32.5067 33.1124 32.2397 33.1111 31.9476V4.05244C33.1111 3.76156 32.9902 3.49459 32.7484 3.25156C32.5067 3.00852 32.2403 2.88763 31.9494 2.88889H4.05055C3.76093 2.88889 3.49459 3.00978 3.25156 3.25156C3.00852 3.49333 2.88763 3.75967 2.88889 4.05055V31.9494C2.88889 32.2391 3.00978 32.5054 3.25156 32.7484C3.49333 32.9915 3.75967 33.1124 4.05055 33.1111"
            fill="#1B91BF"
          />
          <path
            d="M4.05244 33.1111H31.9494C32.2391 33.1111 32.5054 32.9902 32.7484 32.7484C32.9915 32.5067 33.1124 32.2397 33.1111 31.9476V4.05244C33.1111 3.76156 32.9902 3.49459 32.7484 3.25156C32.5067 3.00852 32.2403 2.88763 31.9494 2.88889H4.05055C3.76093 2.88889 3.49459 3.00978 3.25156 3.25156C3.00852 3.49333 2.88763 3.75967 2.88889 4.05055V31.9494C2.88889 32.2391 3.00978 32.5054 3.25156 32.7484C3.49333 32.9915 3.75967 33.1124 4.05055 33.1111M2.88889 33.1111V2.88889M5.94133 26.4282H7.61111V23.4494H28.3889V26.4282H30.0606V19.955C30.0606 19.4639 29.9346 18.9507 29.6828 18.4156C29.4309 17.8804 29.0846 17.4535 28.6439 17.1349V13.9313C28.6439 13.0624 28.3524 12.3365 27.7693 11.7534C27.1863 11.1704 26.4603 10.8795 25.5914 10.8808H20.108C19.6156 10.8808 19.1938 10.9702 18.8424 11.149C18.4911 11.3291 18.2103 11.574 18 11.8838C17.7897 11.574 17.5089 11.3291 17.1576 11.149C16.8062 10.9702 16.3844 10.8808 15.892 10.8808H10.4104C9.54155 10.8808 8.81559 11.1717 8.23255 11.7534C7.64952 12.3352 7.35863 13.0612 7.35989 13.9313V17.1349C6.91915 17.4547 6.57285 17.8816 6.321 18.4156C6.06915 18.9495 5.94322 19.4626 5.94322 19.955L5.94133 26.4282ZM7.61111 21.7778V19.8889C7.61111 19.3537 7.79244 18.9054 8.15511 18.544C8.51778 18.1826 8.96607 18.0013 9.5 18H26.5C27.0352 18 27.4841 18.1813 27.8468 18.544C28.2094 18.9067 28.3901 19.355 28.3889 19.8889V21.7778H7.61111ZM9.02778 16.3302V13.7122C9.02778 13.3722 9.1367 13.0939 9.35455 12.8773C9.57241 12.6595 9.85133 12.5506 10.1913 12.5506H16.0016C16.3416 12.5506 16.6199 12.6595 16.8364 12.8773C17.0556 13.0952 17.1651 13.3735 17.1651 13.7122V16.3283L9.02778 16.3302ZM18.8349 16.3302V13.7122C18.8349 13.3722 18.9444 13.0939 19.1636 12.8773C19.3814 12.6595 19.6597 12.5506 19.9984 12.5506H25.8106C26.1493 12.5506 26.4276 12.6595 26.6454 12.8773C26.8633 13.0952 26.9722 13.3735 26.9722 13.7122V16.3283L18.8349 16.3302ZM4.05244 35C3.1823 35 2.45633 34.7091 1.87456 34.1273C1.29278 33.5456 1.00126 32.8196 1 31.9494V4.05055C1 3.18167 1.29152 2.45633 1.87456 1.87456C2.45759 1.29278 3.18293 1.00126 4.05055 1H31.9494C32.8183 1 33.5437 1.29152 34.1254 1.87456C34.7072 2.45759 34.9987 3.18356 35 4.05244V31.9494C35 32.8183 34.7085 33.5443 34.1254 34.1273C33.5424 34.7104 32.8171 35.0013 31.9494 35H4.05244Z"
            stroke="#1B91BF"
          />
        </svg>
      ),

      badgeCount: 21,
    },
    {
      name: "Caravans",
      icon: (
        <svg width="46" height="34" viewBox="0 0 46 34" fill="none">
          <path
            d="M16.6247 21.25C13.083 21.25 10.2497 24.0833 10.2497 27.625C10.2497 31.1667 13.083 34 16.6247 34C20.1663 34 22.9997 31.1667 22.9997 27.625C22.9997 24.0833 20.1663 21.25 16.6247 21.25ZM16.6247 31.1667C14.6413 31.1667 13.083 29.6083 13.083 27.625C13.083 25.6417 14.6413 24.0833 16.6247 24.0833C18.608 24.0833 20.1663 25.6417 20.1663 27.625C20.1663 29.6083 18.608 31.1667 16.6247 31.1667Z"
            fill="#1B91BF"
          />
          <path
            d="M44.2497 25.5H41.4163V14.875C41.4163 14.1667 41.2747 13.4583 40.8497 12.75L34.8997 2.125C34.1913 0.708333 32.7747 0 31.2163 0H4.58301C2.17467 0 0.333008 1.84167 0.333008 4.25V24.0833C0.333008 26.4917 2.17467 28.3333 4.58301 28.3333H7.41634V25.5H4.58301C3.73301 25.5 3.16634 24.9333 3.16634 24.0833V4.25C3.16634 3.4 3.73301 2.83333 4.58301 2.83333H31.2163C31.783 2.83333 32.208 3.11667 32.4913 3.54167L38.4413 14.1667C38.583 14.3083 38.583 14.5917 38.583 14.875V25.5H32.9163V8.5H22.9997V19.8333H25.833V11.3333H30.083V25.5H25.833V28.3333H44.2497C45.0997 28.3333 45.6663 27.7667 45.6663 26.9167C45.6663 26.0667 45.0997 25.5 44.2497 25.5Z"
            fill="#1B91BF"
          />
          <path
            d="M20.1663 8.5H7.41634V17H20.1663V8.5ZM17.333 14.1667H10.2497V11.3333H17.333V14.1667Z"
            fill="#1B91BF"
          />
        </svg>
      ),
      badgeCount: 21,
    },
    {
      name: "Huts",
      icon: (
        <svg width="40" height="34" viewBox="0 0 40 34" fill="none">
          <path
            d="M20.7999 0.27916C20.5679 0.0982485 20.282 0 19.9878 0C19.6936 0 19.4078 0.0982485 19.1757 0.27916L0.383789 14.9322L2.00928 16.9879L4.30695 15.1963V31.3846C4.30833 32.0778 4.58433 32.7422 5.07452 33.2324C5.56471 33.7226 6.22915 33.9986 6.92238 34H33.0768C33.77 33.9986 34.4344 33.7226 34.9246 33.2324C35.4148 32.7422 35.6908 32.0778 35.6922 31.3846V15.2081L37.9899 16.9997L39.6154 14.9439L20.7999 0.27916ZM22.615 31.3846H17.3841V20.9228H22.615V31.3846ZM25.2304 31.3846V20.9228C25.2304 20.2292 24.9549 19.5639 24.4644 19.0734C23.9739 18.5829 23.3087 18.3074 22.615 18.3074H17.3841C16.6905 18.3074 16.0252 18.5829 15.5347 19.0734C15.0443 19.5639 14.7687 20.2292 14.7687 20.9228V31.3846H6.92238V13.1576L19.9996 2.97045L33.0768 13.1707V31.3846H25.2304Z"
            fill="#1B91BF"
          />
        </svg>
      ),
      badgeCount: 21,
    },
  ];

  const [heartSelect, setHeartSelect] = useState({});

  const toggleHeart = (id) => {
    setHeartSelect((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  return (
    <React.Fragment>
      <section className="commonpad">
        <Container fluid>
          <Row className="mobileSearch">
            <div className="homeSearch">
              <Form.Group>
                <Icon
                  icon="ri:search-line"
                  className="searchIcon"
                  fontSize={23}
                  color={"#000000"}
                />
                <Form.Control
                  placeholder="Search here.."
                  type="text"
                ></Form.Control>
              </Form.Group>

              <Button variant="primary" onClick={() => setModalShow1(true)}>
                <Icon icon="mage:filter" fontSize={25} color={"#000000"} />
              </Button>
            </div>
          </Row>

          <Row className="hideMobileFilter">
            <Col md={12}>
              <div className="filterBox">
                <Form.Group className="rBorder p-0">
                  <Form.Label>Location</Form.Label>
                  <Dropdown>
                    <Dropdown.Toggle id="location">
                      <Icon
                        icon="ion:location-sharp"
                        fontSize={25}
                        color={"#D6D7D8"}
                      />{" "}
                      New York, USA
                      <Icon
                        icon="fluent:chevron-down-20-filled"
                        fontSize={22}
                        color={"#000000"}
                        className="chevron"
                      />
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="locationMenus">
                      <Dropdown.Item>
                        123 lorem ipsum street 11 , New York , USA
                      </Dropdown.Item>
                      <Dropdown.Item>
                        123 lorem ipsum street 11 , New York , USA
                      </Dropdown.Item>
                      <Dropdown.Item>
                        123 lorem ipsum street 11 , New York , USA
                      </Dropdown.Item>
                      <Dropdown.Item>
                        123 lorem ipsum street 11 , New York , USA
                      </Dropdown.Item>
                      <Dropdown.Item>
                        123 lorem ipsum street 11 , New York , USA
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Form.Group>
                <Form.Group className="rBorder">
                  <Form.Label>Check In</Form.Label>
                  <Dropdown>
                    <Dropdown.Toggle id="location">
                      <Icon
                        icon="ion:location-sharp"
                        fontSize={25}
                        color={"#D6D7D8"}
                      />{" "}
                      02 January 2024
                      <Icon
                        icon="fluent:chevron-down-20-filled"
                        fontSize={22}
                        color={"#000000"}
                        className="chevron"
                      />
                    </Dropdown.Toggle>
                    {/* <Dropdown.Menu className="locationMenus">
                      <Dropdown.Item>
                        123 lorem ipsum street 11 , New York , USA
                      </Dropdown.Item>
                      <Dropdown.Item>
                        123 lorem ipsum street 11 , New York , USA
                      </Dropdown.Item>
                      <Dropdown.Item>
                        123 lorem ipsum street 11 , New York , USA
                      </Dropdown.Item>
                      <Dropdown.Item>
                        123 lorem ipsum street 11 , New York , USA
                      </Dropdown.Item>
                      <Dropdown.Item>
                        123 lorem ipsum street 11 , New York , USA
                      </Dropdown.Item>
                    </Dropdown.Menu> */}
                  </Dropdown>
                </Form.Group>
                <Form.Group className="rBorder">
                  <Form.Label>Check Out</Form.Label>
                  <Dropdown>
                    <Dropdown.Toggle id="location">
                      <Icon
                        icon="ion:location-sharp"
                        fontSize={25}
                        color={"#D6D7D8"}
                      />{" "}
                      02 January 2024
                      <Icon
                        icon="fluent:chevron-down-20-filled"
                        fontSize={22}
                        color={"#000000"}
                        className="chevron"
                      />
                    </Dropdown.Toggle>
                    {/* <Dropdown.Menu className="locationMenus">
                      <Dropdown.Item>
                        123 lorem ipsum street 11 , New York , USA
                      </Dropdown.Item>
                      <Dropdown.Item>
                        123 lorem ipsum street 11 , New York , USA
                      </Dropdown.Item>
                      <Dropdown.Item>
                        123 lorem ipsum street 11 , New York , USA
                      </Dropdown.Item>
                      <Dropdown.Item>
                        123 lorem ipsum street 11 , New York , USA
                      </Dropdown.Item>
                      <Dropdown.Item>
                        123 lorem ipsum street 11 , New York , USA
                      </Dropdown.Item>
                    </Dropdown.Menu> */}
                  </Dropdown>
                </Form.Group>
                <Form.Group className="rBorder">
                  <Form.Label>Guest</Form.Label>
                  <Dropdown>
                    <Dropdown.Toggle id="location" className="text-start">
                      <Icon
                        icon="ion:location-sharp"
                        fontSize={25}
                        color={"#D6D7D8"}
                      />{" "}
                      2 adults, <br />2 children,2 pets
                      <Icon
                        icon="fluent:chevron-down-20-filled"
                        fontSize={22}
                        color={"#000000"}
                        className="chevron"
                      />
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="quantityBox">
                      <Dropdown.Item>
                        <div>
                          <span>Adults</span>
                          <div className="pro_counter">
                            <div className="icon_Pro">
                              <Icon
                                onClick={CounterD}
                                color="#000000"
                                icon="clarity:minus-line"
                              />
                            </div>
                            <span>{num}</span>
                            <div className="icon_Pro">
                              <Icon
                                onClick={CounterI}
                                color="#000000"
                                icon="basil:plus-outline"
                              />
                            </div>
                          </div>
                        </div>

                        <div>
                          <span>Children</span>
                          <div className="pro_counter">
                            <div className="icon_Pro">
                              <Icon
                                onClick={CounterD1}
                                color="#000000"
                                icon="clarity:minus-line"
                              />
                            </div>
                            <span>{num1}</span>
                            <div className="icon_Pro">
                              <Icon
                                onClick={CounterI1}
                                color="#000000"
                                icon="basil:plus-outline"
                              />
                            </div>
                          </div>
                        </div>

                        <div>
                          <span>Pets</span>
                          <div className="pro_counter">
                            <div className="icon_Pro">
                              <Icon
                                onClick={CounterD2}
                                color="#000000"
                                icon="clarity:minus-line"
                              />
                            </div>
                            <span>{num2}</span>
                            <div className="icon_Pro">
                              <Icon
                                onClick={CounterI2}
                                color="#000000"
                                icon="basil:plus-outline"
                              />
                            </div>
                          </div>
                        </div>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Form.Group>
                <Form.Group
                  className="filterLink"
                  onClick={() => setModalShow(true)}
                >
                  <Image src={IMAGES.Filter} alt="" />
                  <h4>Advanced</h4>
                </Form.Group>
                <Button variant="primary">
                  <Icon
                    icon="iconoir:search"
                    fontSize={25}
                    color={"#ffffff"}
                    className="me-2"
                  />
                  Search
                </Button>
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <div className="sliderCatPad">
                <SliderCategory items={items} />
              </div>
            </Col>
          </Row>

          <Row className="rowReverse">
            <Col md={12} lg={12} xl={7}>
              <Row className="listingMobTop">
                {listingsData.map((listing) => (
                  <Col className="colxl" key={listing.id} xl={4} md={6}>
                    <div className="listing">
                      <div className="listImgBox">
                        <div className="starRating">
                          <Icon icon="ph:star-fill" />
                          {listing.rating}
                        </div>
                        <div
                          className="heartBox"
                          onClick={() => toggleHeart(listing.id)}
                        >
                          {heartSelect[listing.id] ? (
                            <Icon icon="ph:heart-fill" color="#ffffff" />
                          ) : (
                            <Icon icon="ph:heart-light" />
                          )}
                        </div>
                      </div>
                      <Carousel data-bs-theme="dark">
                        {listing.images.map((image, index) => (
                          <Carousel.Item key={index}>
                            <div
                              className="listImage"
                              style={{ backgroundImage: `url(${image})` }}
                            ></div>
                          </Carousel.Item>
                        ))}
                      </Carousel>
                      <div className="listing_body">
                        <div className="listing_body_pad">
                          <h2>{listing.title}</h2>
                          <h3>
                            <Icon icon="system-uicons:location" />{" "}
                            {listing.location}
                          </h3>
                          <div className="listing_iconFlex">
                            {listing.amenities.map((amenity, index) => (
                              <Icon key={index} icon={amenity} />
                            ))}
                          </div>
                        </div>
                        <div className="listing_body_pad listing_body_footer">
                          <h5>{listing.price}</h5>
                          <Button
                            as={Link}
                            to={"/property-detail"}
                            variant="outline-primary"
                          >
                            Show More
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
              <div className="d-flex align-items-center justify-content-center mt-3">
                <Pagination>
                  <Pagination.First>
                    <Icon icon="tabler:chevron-left" color="#70778A" />
                  </Pagination.First>
                  <Pagination.Item active>{1}</Pagination.Item>
                  <Pagination.Item>{2}</Pagination.Item>
                  <Pagination.Last>
                    <Icon icon="tabler:chevron-right" color="#000000" />
                  </Pagination.Last>
                </Pagination>
              </div>
            </Col>
            <Col md={12} lg={12} xl={5}>
              <Image src={IMAGES.Map_Img} className="mapFull desktop" alt="" />
              <Image src={IMAGES.Map_Img2} className="mapFull mobile" alt="" />
            </Col>
          </Row>
        </Container>
      </section>
      <AdvancedFilterModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
       <AdvancedFilterModalMobile
        show={modalShow2}
        onHide={() => setModalShow2(false)}
      />
      <FilterModal
        show={modalShow1}
        onModalClick={() => setModalShow2(true)}
        onHide={() => setModalShow1(false)}
      />
    </React.Fragment>
  );
};

const DATA_Property = [
  {
    id: 1,
    name: "Villa",
  },
  {
    id: 2,
    name: "Hotel",
  },
  {
    id: 3,
    name: "Apartment",
  },
  {
    id: 4,
    name: "Room",
  },
  {
    id: 5,
    name: "Caravan",
  },
  {
    id: 6,
    name: "Huts",
  },
];

const DATA_Facilities = [
  {
    id: 1,
    name: "Pool",
  },
  {
    id: 2,
    name: "Jacuzzi",
  },
  {
    id: 3,
    name: "Wifi",
  },
  {
    id: 4,
    name: "Tv",
  },
  {
    id: 5,
    name: "Grill",
  },
  {
    id: 6,
    name: "Parking Spot",
  },
  {
    id: 7,
    name: "Breakfast",
  },
  {
    id: 8,
    name: "Allowed Pets",
  },
  {
    id: 9,
    name: "Can Smoke Inside",
  },
];

const options = [
  { label: "Any", value: "any" },
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "6", value: "6" },
  { label: "7", value: "7" },
  { label: "8+", value: "8+" },
];

const options1 = [
  { label: "Any", value: "any" },
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "6", value: "6" },
  { label: "7", value: "7" },
  { label: "8+", value: "8+" },
];

function AdvancedFilterModal(props) {
  const [selectedOption, setSelectedOption] = useState("option1");

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const [selectedOption1, setSelectedOption1] = useState("option1");

  const handleOptionChange1 = (event) => {
    setSelectedOption1(event.target.value);
  };

  const [num, setNum] = useState(1);
  const [num1, setNum1] = useState(1);
  const [num2, setNum2] = useState(1);

  const CounterI = (e) => {
    e.stopPropagation();
    setNum(num + 1);
  };

  const CounterI1 = (e) => {
    e.stopPropagation();
    setNum1(num1 + 1);
  };

  const CounterI2 = (e) => {
    e.stopPropagation();
    setNum2(num2 + 1);
  };

  const CounterD = (e) => {
    e.stopPropagation();
    setNum(num - 1);
    if (num === 0) {
      setNum(0);
    }
  };

  const CounterD1 = (e) => {
    e.stopPropagation();
    setNum1(num1 - 1);
    if (num1 === 0) {
      setNum1(0);
    }
  };

  const CounterD2 = (e) => {
    e.stopPropagation();
    setNum2(num2 - 1);
    if (num2 === 0) {
      setNum2(0);
    }
  };

  const [rating, setRating] = useState(0);

  const handleStarClick = (clickedIndex) => {
    setRating(clickedIndex + 1);
  };

  const [values, setValues] = useState([100, 450]);

  const handleSliderChange = (newValues) => {
    setValues(newValues);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modalWidth"
    >
      <Modal.Body
        tyle={{
          maxHeight: "calc(100vh - 210px)",
          overflowY: "auto",
        }}
      >
        <Icon
          icon="carbon:close-outline"
          fontSize={32}
          color={"#CF0000"}
          onClick={props.onHide}
          className="crossModal"
        />
        <h2 className="text-center">Advanced Filter</h2>
        <div className="modal_Header">
          <h3>Property Type</h3>
          <Link className="showAll">Show All</Link>
        </div>
        <div className="checkBoxes">
          {DATA_Property.map((item, index) => (
            <div key={`property-checkbox-${index}`} className="mb-3">
              <Form.Check
                type="checkbox"
                id={`property-checkbox-${index}`}
                label={item.name}
              />
            </div>
          ))}
        </div>
        <div className="modal_Header">
          <h3>Facilities</h3>
          <Link className="showAll">Show All</Link>
        </div>
        <div className="checkBoxes">
          {DATA_Facilities.map((item, index) => (
            <div key={`facilities-checkbox-${index}`} className="mb-3">
              <Form.Check
                type="checkbox"
                id={`facilities-checkbox-${index}`}
                label={item.name}
              />
            </div>
          ))}
        </div>
        {/* <div className="modal_Header">
          <h3>Areas/Zones/Cities</h3>
        </div>
        <Form.Control
          type="text"
          placeholder="Enter Areas/Zones/Cities"
          className="inputNormal"
        ></Form.Control> */}
        <div className="modal_Header">
          <h3>Bedrooms</h3>
        </div>
        <div className="radio-group">
          {options.map((option) => (
            <CustomRadioButton
              key={option.value}
              label={option.label}
              value={option.value}
              checked={selectedOption === option.value}
              onChange={handleOptionChange}
            />
          ))}
        </div>
        <div className="modal_Header">
          <h3>Bathrooms</h3>
        </div>
        <div className="radio-group">
          {options1.map((option) => (
            <CustomRadioButton
              key={option.value}
              label={option.label}
              value={option.value}
              checked={selectedOption1 === option.value}
              onChange={handleOptionChange1}
            />
          ))}
        </div>
        <div className="modal_Header">
          <h3>Guests</h3>
        </div>
        <div className="quBox">
          <div>
            <span>Adults</span>
            <div className="pro_counter">
              <div className="icon_Pro">
                <Icon
                  onClick={CounterD}
                  color="#000000"
                  icon="clarity:minus-line"
                />
              </div>
              <span>{num}</span>
              <div className="icon_Pro">
                <Icon
                  onClick={CounterI}
                  color="#000000"
                  icon="basil:plus-outline"
                />
              </div>
            </div>
          </div>

          <div>
            <span>Children</span>
            <div className="pro_counter">
              <div className="icon_Pro">
                <Icon
                  onClick={CounterD1}
                  color="#000000"
                  icon="clarity:minus-line"
                />
              </div>
              <span>{num1}</span>
              <div className="icon_Pro">
                <Icon
                  onClick={CounterI1}
                  color="#000000"
                  icon="basil:plus-outline"
                />
              </div>
            </div>
          </div>

          <div>
            <span>Pets</span>
            <div className="pro_counter">
              <div className="icon_Pro">
                <Icon
                  onClick={CounterD2}
                  color="#000000"
                  icon="clarity:minus-line"
                />
              </div>
              <span>{num2}</span>
              <div className="icon_Pro">
                <Icon
                  onClick={CounterI2}
                  color="#000000"
                  icon="basil:plus-outline"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="modal_Header">
          <h3>Price</h3>
        </div>
        <div className="reactSliderFlex">
          <ReactSlider
            className="horizontal-slider horizontal-slider1"
            thumbClassName="example-thumb"
            trackClassName="example-track"
            value={values}
            onChange={handleSliderChange}
            ariaLabel={["Lower thumb", "Upper thumb"]}
            ariaValuetext={(state) => `Thumb value ${state.valueNow}`}
            renderThumb={(props, state) => (
              <div {...props}>{state.valueNow}</div>
            )}
            pearling
            minDistance={10}
            min={100}
            max={450}
          />
        </div>
        <div className="priceRangFlex">
          <div className="rangeControl">
            <h4>Minimum</h4>
            <h5>${values[0]}</h5>
          </div>
          <div className="rangeDivider"></div>
          <div className="rangeControl">
            <h4>Maximum</h4>
            <h5>${values[1]}</h5>
          </div>
        </div>
        <div className="modal_Header">
          <h3>Rating</h3>
        </div>
        <div className="star-rating">
          {[...Array(5)].map((_, index) => (
            <span
              key={index}
              className={index < rating ? "star filled" : "star"}
              onClick={() => handleStarClick(index)}
            >
              <Icon icon="ph:star-fill" />
            </span>
          ))}
        </div>
        <Button onClick={props.onHide}>Apply</Button>
      </Modal.Body>
    </Modal>
  );
}

function AdvancedFilterModalMobile(props) {
  const [selectedOption, setSelectedOption] = useState("option1");

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const [selectedOption1, setSelectedOption1] = useState("option1");

  const handleOptionChange1 = (event) => {
    setSelectedOption1(event.target.value);
  };

  const [num, setNum] = useState(1);
  const [num1, setNum1] = useState(1);
  const [num2, setNum2] = useState(1);

  const CounterI = (e) => {
    e.stopPropagation();
    setNum(num + 1);
  };

  const CounterI1 = (e) => {
    e.stopPropagation();
    setNum1(num1 + 1);
  };

  const CounterI2 = (e) => {
    e.stopPropagation();
    setNum2(num2 + 1);
  };

  const CounterD = (e) => {
    e.stopPropagation();
    setNum(num - 1);
    if (num === 0) {
      setNum(0);
    }
  };

  const CounterD1 = (e) => {
    e.stopPropagation();
    setNum1(num1 - 1);
    if (num1 === 0) {
      setNum1(0);
    }
  };

  const CounterD2 = (e) => {
    e.stopPropagation();
    setNum2(num2 - 1);
    if (num2 === 0) {
      setNum2(0);
    }
  };

  const [rating, setRating] = useState(0);

  const handleStarClick = (clickedIndex) => {
    setRating(clickedIndex + 1);
  };

  const [values, setValues] = useState([100, 450]);

  const handleSliderChange = (newValues) => {
    setValues(newValues);
  };

  return (
    <Modal
      {...props}
      size="lg"
      scrollable={true}
      aria-labelledby="contained-modal-title-vcenter modal-dialog-scrollable"
      centered
      className="phoneModal"
  
    >
      <Modal.Body
        tyle={{
          maxHeight: "calc(100vh - 210px)",
          overflowY: "auto",
        }}
      >
        <Icon
          icon="carbon:close-outline"
          fontSize={32}
          color={"#CF0000"}
          onClick={props.onHide}
          className="crossModal"
        />
        <h2 className="text-center">Advanced Filter</h2>
        <div className="modal_Header">
          <h3>Property Type</h3>
          <Link className="showAll">Show All</Link>
        </div>
        <div className="checkBoxes">
          {DATA_Property.map((item, index) => (
            <div key={`property-checkbox-${index}`} className="mb-3">
              <Form.Check
                type="checkbox"
                id={`property-checkbox-${index}`}
                label={item.name}
              />
            </div>
          ))}
        </div>
        <div className="modal_Header">
          <h3>Facilities</h3>
          <Link className="showAll">Show All</Link>
        </div>
        <div className="checkBoxes">
          {DATA_Facilities.map((item, index) => (
            <div key={`facilities-checkbox-${index}`} className="mb-3">
              <Form.Check
                type="checkbox"
                id={`facilities-checkbox-${index}`}
                label={item.name}
              />
            </div>
          ))}
        </div>
        {/* <div className="modal_Header">
          <h3>Areas/Zones/Cities</h3>
        </div>
        <Form.Control
          type="text"
          placeholder="Enter Areas/Zones/Cities"
          className="inputNormal"
        ></Form.Control> */}
        <div className="modal_Header">
          <h3>Bedrooms</h3>
        </div>
        <div className="radio-group">
          {options.map((option) => (
            <CustomRadioButton
              key={option.value}
              label={option.label}
              value={option.value}
              checked={selectedOption === option.value}
              onChange={handleOptionChange}
            />
          ))}
        </div>
        {/* <div className="modal_Header">
          <h3>Bathrooms</h3>
        </div>
        <div className="radio-group">
          {options1.map((option) => (
            <CustomRadioButton
              key={option.value}
              label={option.label}
              value={option.value}
              checked={selectedOption1 === option.value}
              onChange={handleOptionChange1}
            />
          ))}
        </div> */}
        <div className="modal_Header">
          <h3>Guests</h3>
        </div>
        <div className="quBox">
          <div>
            <span>Adults</span>
            <div className="pro_counter">
              <div className="icon_Pro">
                <Icon
                  onClick={CounterD}
                  color="#000000"
                  icon="clarity:minus-line"
                />
              </div>
              <span>{num}</span>
              <div className="icon_Pro">
                <Icon
                  onClick={CounterI}
                  color="#000000"
                  icon="basil:plus-outline"
                />
              </div>
            </div>
          </div>

          <div>
            <span>Children</span>
            <div className="pro_counter">
              <div className="icon_Pro">
                <Icon
                  onClick={CounterD1}
                  color="#000000"
                  icon="clarity:minus-line"
                />
              </div>
              <span>{num1}</span>
              <div className="icon_Pro">
                <Icon
                  onClick={CounterI1}
                  color="#000000"
                  icon="basil:plus-outline"
                />
              </div>
            </div>
          </div>

          <div>
            <span>Pets</span>
            <div className="pro_counter">
              <div className="icon_Pro">
                <Icon
                  onClick={CounterD2}
                  color="#000000"
                  icon="clarity:minus-line"
                />
              </div>
              <span>{num2}</span>
              <div className="icon_Pro">
                <Icon
                  onClick={CounterI2}
                  color="#000000"
                  icon="basil:plus-outline"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="modal_Header">
          <h3>Price</h3>
        </div>
        <div className="reactSliderFlex">
          <ReactSlider
            className="horizontal-slider horizontal-slider1"
            thumbClassName="example-thumb"
            trackClassName="example-track"
            value={values}
            onChange={handleSliderChange}
            ariaLabel={["Lower thumb", "Upper thumb"]}
            ariaValuetext={(state) => `Thumb value ${state.valueNow}`}
            renderThumb={(props, state) => (
              <div {...props}>{state.valueNow}</div>
            )}
            pearling
            minDistance={10}
            min={100}
            max={450}
          />
        </div>
        <div className="priceRangFlex">
          <div className="rangeControl">
            <h4>Minimum</h4>
            <h5>${values[0]}</h5>
          </div>
          <div className="rangeDivider"></div>
          <div className="rangeControl">
            <h4>Maximum</h4>
            <h5>${values[1]}</h5>
          </div>
        </div>
        <div className="modal_Header">
          <h3>Rating</h3>
        </div>
        <div className="star-rating">
          {[...Array(5)].map((_, index) => (
            <span
              key={index}
              className={index < rating ? "star filled" : "star"}
              onClick={() => handleStarClick(index)}
            >
              <Icon icon="ph:star-fill" />
            </span>
          ))}
        </div>
        <Button onClick={props.onHide}>Apply</Button>
      </Modal.Body>
    </Modal>
  );
}

function FilterModal(props) {
  const [num, setNum] = useState(1);
  const [num1, setNum1] = useState(1);
  const [num2, setNum2] = useState(1);

  const CounterI = (e) => {
    e.stopPropagation();
    setNum(num + 1);
  };

  const CounterI1 = (e) => {
    e.stopPropagation();
    setNum1(num1 + 1);
  };

  const CounterI2 = (e) => {
    e.stopPropagation();
    setNum2(num2 + 1);
  };

  const CounterD = (e) => {
    e.stopPropagation();
    setNum(num - 1);
    if (num === 0) {
      setNum(0);
    }
  };

  const CounterD1 = (e) => {
    e.stopPropagation();
    setNum1(num1 - 1);
    if (num1 === 0) {
      setNum1(0);
    }
  };

  const CounterD2 = (e) => {
    e.stopPropagation();
    setNum2(num2 - 1);
    if (num2 === 0) {
      setNum2(0);
    }
  };

  return (
    <Modal {...props} size="lg" className="phoneModal">
      <Modal.Body>
        <Icon
          icon="carbon:close-outline"
          fontSize={32}
          color={"#CF0000"}
          onClick={props.onHide}
          className="crossModal"
        />
        <h2 className="text-left">Where to?</h2>
        <Row>
          <Col md={12}>
            <div className="filterBox">
              <Form.Group className="rBorder borderBttom p-0">
                <Form.Label>Location</Form.Label>
                <Dropdown>
                  <Dropdown.Toggle id="location">
                    <Icon
                      icon="ion:location-sharp"
                      fontSize={25}
                      color={"#D6D7D8"}
                    />{" "}
                    New York, USA
                    <Icon
                      icon="fluent:chevron-down-20-filled"
                      fontSize={22}
                      color={"#000000"}
                      className="chevron"
                    />
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="locationMenus">
                    <Dropdown.Item>
                      123 lorem ipsum street 11 , New York , USA
                    </Dropdown.Item>
                    <Dropdown.Item>
                      123 lorem ipsum street 11 , New York , USA
                    </Dropdown.Item>
                    <Dropdown.Item>
                      123 lorem ipsum street 11 , New York , USA
                    </Dropdown.Item>
                    <Dropdown.Item>
                      123 lorem ipsum street 11 , New York , USA
                    </Dropdown.Item>
                    <Dropdown.Item>
                      123 lorem ipsum street 11 , New York , USA
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Form.Group>
              <div className="borderBttom">
                <Row className="iconSize">
                  <Col xs={6} className="rBorder1">
                    <Form.Group className="rBorder">
                      <Form.Label>Check In</Form.Label>
                      <Dropdown>
                        <Dropdown.Toggle id="location">
                          <Icon
                            icon="ion:location-sharp"
                            fontSize={25}
                            color={"#D6D7D8"}
                          />{" "}
                          02 January 2024
                          <Icon
                            icon="fluent:chevron-down-20-filled"
                            fontSize={22}
                            color={"#000000"}
                            className="chevron"
                          />
                        </Dropdown.Toggle>
                        {/* <Dropdown.Menu className="locationMenus">
                        <Dropdown.Item>
                          123 lorem ipsum street 11 , New York , USA
                        </Dropdown.Item>
                        <Dropdown.Item>
                          123 lorem ipsum street 11 , New York , USA
                        </Dropdown.Item>
                        <Dropdown.Item>
                          123 lorem ipsum street 11 , New York , USA
                        </Dropdown.Item>
                        <Dropdown.Item>
                          123 lorem ipsum street 11 , New York , USA
                        </Dropdown.Item>
                        <Dropdown.Item>
                          123 lorem ipsum street 11 , New York , USA
                        </Dropdown.Item>
                      </Dropdown.Menu> */}
                      </Dropdown>
                    </Form.Group>
                  </Col>
                  <Col xs={6}>
                    <Form.Group className="rBorder">
                      <Form.Label>Check Out</Form.Label>
                      <Dropdown>
                        <Dropdown.Toggle id="location">
                          <Icon
                            icon="ion:location-sharp"
                            fontSize={25}
                            color={"#D6D7D8"}
                          />{" "}
                          02 January 2024
                          <Icon
                            icon="fluent:chevron-down-20-filled"
                            fontSize={22}
                            color={"#000000"}
                            className="chevron"
                          />
                        </Dropdown.Toggle>
                        {/* <Dropdown.Menu className="locationMenus">
                        <Dropdown.Item>
                          123 lorem ipsum street 11 , New York , USA
                        </Dropdown.Item>
                        <Dropdown.Item>
                          123 lorem ipsum street 11 , New York , USA
                        </Dropdown.Item>
                        <Dropdown.Item>
                          123 lorem ipsum street 11 , New York , USA
                        </Dropdown.Item>
                        <Dropdown.Item>
                          123 lorem ipsum street 11 , New York , USA
                        </Dropdown.Item>
                        <Dropdown.Item>
                          123 lorem ipsum street 11 , New York , USA
                        </Dropdown.Item>
                      </Dropdown.Menu> */}
                      </Dropdown>
                    </Form.Group>
                  </Col>
                </Row>
              </div>
              <Form.Group className="rBorder borderBttom">
                <Form.Label>Guest</Form.Label>
                <Dropdown>
                  <Dropdown.Toggle id="location" className="text-start">
                    <Icon
                      icon="ion:location-sharp"
                      fontSize={25}
                      color={"#D6D7D8"}
                    />{" "}
                    2 adults, 2 children,2 pets
                    <Icon
                      icon="fluent:chevron-down-20-filled"
                      fontSize={22}
                      color={"#000000"}
                      className="chevron"
                    />
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="quantityBox">
                    <Dropdown.Item>
                      <div>
                        <span>Adults</span>
                        <div className="pro_counter">
                          <div className="icon_Pro">
                            <Icon
                              onClick={CounterD}
                              color="#000000"
                              icon="clarity:minus-line"
                            />
                          </div>
                          <span>{num}</span>
                          <div className="icon_Pro">
                            <Icon
                              onClick={CounterI}
                              color="#000000"
                              icon="basil:plus-outline"
                            />
                          </div>
                        </div>
                      </div>

                      <div>
                        <span>Children</span>
                        <div className="pro_counter">
                          <div className="icon_Pro">
                            <Icon
                              onClick={CounterD1}
                              color="#000000"
                              icon="clarity:minus-line"
                            />
                          </div>
                          <span>{num1}</span>
                          <div className="icon_Pro">
                            <Icon
                              onClick={CounterI1}
                              color="#000000"
                              icon="basil:plus-outline"
                            />
                          </div>
                        </div>
                      </div>

                      <div>
                        <span>Pets</span>
                        <div className="pro_counter">
                          <div className="icon_Pro">
                            <Icon
                              onClick={CounterD2}
                              color="#000000"
                              icon="clarity:minus-line"
                            />
                          </div>
                          <span>{num2}</span>
                          <div className="icon_Pro">
                            <Icon
                              onClick={CounterI2}
                              color="#000000"
                              icon="basil:plus-outline"
                            />
                          </div>
                        </div>
                      </div>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Form.Group>
            </div>
            <Link className="adFilter" onClick={props.onModalClick}>
                Advanced Filter
              </Link>
          </Col>
        </Row>

        <Button onClick={props.onHide} className="w-100">
          Search
        </Button>
      </Modal.Body>
    </Modal>
  );
}

export default SearchScreen;
